import React from 'react';
import { motion } from 'framer-motion';
import { SettingsIcon, ScanSearchIcon, MousePointerClickIcon } from 'lucide-react';
const steps = [{
  title: 'Configura tu Riesgo',
  description: 'Eliges qué porcentaje de tu cuenta estás dispuesto a arriesgar (ej. 0.5%).',
  icon: SettingsIcon,
  number: '01'
}, {
  title: 'Detecta la Caja',
  description: 'El Pandora Box marca la zona de acumulación antes de la apertura de NY.',
  icon: ScanSearchIcon,
  number: '02'
}, {
  title: 'Ejecuta con un Clic',
  description: 'Cuando el precio rompa la zona, Sniper Panel entra al mercado con el lotaje exacto y el SL puesto.',
  icon: MousePointerClickIcon,
  number: '03'
}];
export function HowItWorks() {
  return <section className="py-24 bg-dark border-y border-surfaceHighlight relative overflow-hidden" data-id="element-146">
      <div className="absolute inset-0 bg-circuit opacity-10" data-id="element-147"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <div className="text-center mb-20" data-id="element-149">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white uppercase tracking-wide" data-id="element-150">
            Protocolo de <span className="text-primary" data-id="element-151">Ejecución</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-152">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-surfaceHighlight" data-id="element-153">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/50 to-primary/0" data-id="element-154"></div>
          </div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center glass-panel p-8 rounded-lg" data-id="element-155">
              <div className="w-20 h-20 bg-dark border border-primary rounded-full flex items-center justify-center mb-6 relative z-10 box-glow" data-id="element-156">
                <span className="absolute -top-2 -right-2 font-display font-bold text-xs bg-primary text-dark w-6 h-6 rounded-full flex items-center justify-center" data-id="element-157">
                  {step.number}
                </span>
                <step.icon className="w-8 h-8 text-primary" data-id="element-158" />
              </div>

              <h3 className="font-display text-xl font-bold text-white mb-4" data-id="element-159">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-160">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}